import { Exception } from '@src/types/Exception';

export class StringUtils {
    /**
     * Formats the string passed as the first argument using the rest of the arguments.
     *
     * @param {string} - A string containing zero or more numbered parameters.
     * @param {...args} - Any number of arguments for the string.
     * @return {string} - The formatted string.
     *
     * Example:
     *  StringUtils.format("Hello {0}", "world"); // Returns "Hello world"
     */
    public static format(s, ...args) {
        if (typeof s === 'undefined') {
            return;
        }

        const replacements = [...args];
        return s.replace(/{(\d+)}/gm, (toReplace, position) => {
            return typeof replacements[position] !== 'undefined' ? replacements[position] : toReplace;
        });
    }

    /**
     * Formats the given string by substituting any named parameters in the string
     * with the given dictionary.
     *
     * @param {string} - a string containing zero or more named parameters. Parameters can be named
     * by prefixing the key with a colon. Eg. to replace the word 'item' in the string 'item cannot be found',
     * set the string to ':item cannot be found' and include a dictionary mapping for 'item'.
     * @param {object} - contains the key-value pairings for named parameter substitution.
     * @return {string} - The formatted string.
     *
     * StringUtils.formatWithNamedParameters(':item cannot be found', {item: 'Salumi Coppa, by weight'})
     * returns 'Salumi Coppa, by weight cannot be found'
     *
     * StringUtils.formatWithNamedParameters(':item cannot be found', {})
     * returns ':item cannot be found'
     */
    public static formatWithNamedParameters(str, dictionary) {
        if (typeof str === 'string' && typeof dictionary === 'object' && dictionary != null) {
            for (const key in dictionary) {
                if (dictionary.hasOwnProperty(key)) {
                    str = str.replace(':' + key, dictionary[key]);
                }
            }
            return str;
        } else {
            throw new Exception({ message: 'Usage: StringUtils.formatWithNamedParameters(string, {})' });
        }
    }
}
